import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import useCouponPatientPayGPIListPlans from "./hooks/useCouponPatientPayGPIListPlans";  
  
const CouponPatientPayGPIListPlans = () => {  
  const couponPatientPayGPIListPlansData = useCouponPatientPayGPIListPlans();  
  
  return (  
    <div class="container container-fluid">  
          <ButtonsSection ctaButtons={couponPatientPayGPIListPlansData.leftButtons} align="left" />   
      <div className="header-section">  
        <h1>  
          {couponPatientPayGPIListPlansData.screen_title} -{" "}  
          <span className="heading-cod">{couponPatientPayGPIListPlansData.screenNumber}</span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={couponPatientPayGPIListPlansData.formFields}  
        dropdownValues={couponPatientPayGPIListPlansData.dropdownValues}  
        paramsData={couponPatientPayGPIListPlansData.paramsData}  
        updataParamData={couponPatientPayGPIListPlansData.updateParamData}  
         useNewLayout={true}
         firstRowCount = {2}
         secondRowCount ={3}
      />  
      <ButtonsSection ctaButtons={couponPatientPayGPIListPlansData.ctaButtons} />  
      <DisplayTable  
        data={couponPatientPayGPIListPlansData.data}  
        parmKey={couponPatientPayGPIListPlansData.parmKey}  
        menuOptions={couponPatientPayGPIListPlansData.menuOptions}  
        tableHeaders={couponPatientPayGPIListPlansData.columnDef}  
        setRowData={couponPatientPayGPIListPlansData.setRowData}  
        selectedPriceSchedules={couponPatientPayGPIListPlansData.selectedRows}  
        setSelectedPriceSchedules={couponPatientPayGPIListPlansData.setSelectedRows}  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={couponPatientPayGPIListPlansData.first}  
          rows={couponPatientPayGPIListPlansData.rows}  
          totalRecords={couponPatientPayGPIListPlansData.totalRecords}  
          currentPage={couponPatientPayGPIListPlansData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={couponPatientPayGPIListPlansData.onPageChange}  
        />  
      </div>    
    </div>  
  );  
};  
  
export default CouponPatientPayGPIListPlans;